import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');

export class LayerMenuSwitcherButtonComponent extends HTMLElement{
    constructor(){
        super();
        const key = this.getAttribute('data-key')
        const active = this.getAttribute('data-active')

        let activeClass = ''
        if(active === 'true') {
            activeClass = 'active'
        }

        template.innerHTML = `
            <input type="radio" value="vertical" name="rdiLayerSwitcher">
            <layout-language data-key="` + key + `"></layout-language>
        `;

        initWebComponent(this, template)
    }
}
